// extracted by mini-css-extract-plugin
module.exports = {"root":"_f715aa","container":"_6659cb","title":"_986102","categoryLeadersContainer":"_ae4159","categoryLeadersBadge":"_35d8a8","categoryLeadersText":"_b83158","category":"_d68b7c"};